import React from 'react';
import { Dropdown } from 'antd';
import MetricsPopup from '@src/components/metrics-panel-hz/control-panel/MetricsPopup';
import MetricSelector from '@src/components/dimension-panel-hz/header/MetricSelector';
import { DownOutlined } from '@ant-design/icons';

const RenderBtn = ({ onClick }) => {
  return <div onClick={onClick}>Dimension Metrics</div>;
};

const items = [
  {
    key: 'dimension-metrics-selector',
    label: <MetricSelector RenderBtn={RenderBtn} />,
  },
];

const menuProps = {
  items,
  onClick: () => null, // ignore as click is handled by dimension metric selector
  selectable: false,
};

function MetricControl() {
  return (
    <>
      <Dropdown.Button
        menu={menuProps}
        placement="bottom"
        icon={<DownOutlined style={{ fontSize: 12 }} />}
        buttonsRender={([_, rightButton]) => [
          <MetricsPopup key="chart-metrics-selector" />,
          rightButton,
        ]}
      />
    </>
  );
}

export default MetricControl;
